import axios from "axios";
import React, { useState, useEffect } from "react";
import { API_ROUTES } from "../../constants/apiRoutes";

const HeaderPopup = () => {
  const [time, setTime] = useState("");

  useEffect(() => {
    const myVar = setInterval(myTimer, 1000);
    return () => clearInterval(myVar);
  }, []);

  function myTimer() {
    const d = new Date();
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    setTime(`${hours}:${minutes}:${seconds}`);
  }

  const [insertData, setInsertData] = useState({
    rate18Karat: 0,
    rate21Karat: 0,
    rate22Karat: 0,
    rate24Karat: 0,
    timestamp: new Date().toLocaleDateString(),
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (/^\d*\.?\d*$/.test(value)) {
      setInsertData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    const token = localStorage.getItem("jwtToken");
    e.preventDefault();
    try {
      await axios.post(
        `${API_ROUTES}Rates/insert`,
        {
          ...insertData,
          rate18Karat: parseFloat(insertData.rate18Karat),
          rate21Karat: parseFloat(insertData.rate21Karat),
          rate22Karat: parseFloat(insertData.rate22Karat),
          rate24Karat: parseFloat(insertData.rate24Karat),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Error:", error);
    }
  };
  return (
    <div>
      <dialog id="my_modal_4" className="modal">
        <div className="modal-box w-full max-w-4xl">
          <h3 className="font-bold text-lg">Gold Rates Update</h3>
          <p className="py-4">
            Update the gold rates below and submit the form.
          </p>
          <form onSubmit={handleSubmit}>
            <table className="table-auto w-full mb-8">
              <thead className="bg-base-200">
                <tr>
                  <th className="px-4 py-2">18Karat Rate</th>
                  <th className="px-4 py-2">21Karat Rate</th>
                  <th className="px-4 py-2">22Karat Rate</th>
                  <th className="px-4 py-2">24Karat Rate</th>
                  <th className="px-4 py-2">Timestamp</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border px-4 py-2">
                    <input
                      type="text"
                      name="rate18Karat"
                      value={insertData.rate18Karat}
                      onChange={handleChange}
                      className="input input-bordered w-full"
                      inputMode="decimal"
                    />
                  </td>
                  <td className="border px-4 py-2">
                    <input
                      type="text"
                      name="rate21Karat"
                      value={insertData.rate21Karat}
                      onChange={handleChange}
                      className="input input-bordered w-full"
                      inputMode="decimal"
                    />
                  </td>
                  <td className="border px-4 py-2">
                    <input
                      type="text"
                      name="rate22Karat"
                      value={insertData.rate22Karat}
                      onChange={handleChange}
                      className="input input-bordered w-full"
                      inputMode="decimal"
                    />
                  </td>
                  <td className="border px-4 py-2">
                    <input
                      type="text"
                      name="rate24Karat"
                      value={insertData.rate24Karat}
                      onChange={handleChange}
                      className="input input-bordered w-full"
                      inputMode="decimal"
                    />
                  </td>
                  <td className="border px-4 py-2">{time}</td>
                </tr>
              </tbody>
            </table>
            <div className="modal-action flex justify-end">
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
              <button
                type="button"
                className="btn"
                onClick={() => document.getElementById("my_modal_4").close()}
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </dialog>
    </div>
  );
};

export default HeaderPopup;
